export class TfaRequest {
  constructor(
    public token: string | null | undefined,
    public passCode: string
  ) {}
}
